import { useLocation } from 'react-router-dom';
import { Form } from 'antd';
import DefaultButton from '../../../buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../../hooks/translation/useTranslation';
import useWindowDimensions from '../../../../../hooks/useWindowDimensions';
import { useModal } from '../../../../../contexts/modalsContext/modalsContext';
import useQuery from '../../../../../hooks/useQuery';

function ContinueDrawer({
  rideSearchForm,
  chosenRides,
}) {
  const query = useQuery();

  const { trans } = useTranslation();
  const location = useLocation();
  const { width } = useWindowDimensions();
  const { setShowTicketSearchDrawer } = useModal();

  const standard = Form.useWatch('standard_passengers', rideSearchForm);
  const disabled = Form.useWatch('disabled_passengers', rideSearchForm);
  const child = Form.useWatch('child_passengers', rideSearchForm);

  const isDisabled = () => {
    if (!chosenRides?.departure?.id) {
      return true;
    }

    if (query.get('returnDateFrom') && !chosenRides?.return?.id) {
      return true;
    }

    return standard + disabled + child === 0;
  };

  return (
    <div className={`${(width < 1024 && (location.pathname.endsWith('/search') || location.pathname.endsWith('/search/'))) ? 'block' : 'hidden'} fixed left-0 bg-white w-screen px-[30px] py-5 bottom-0 rounded-t-3xl shadow-2xl z-[1000]`}>
      <DefaultButton disabled={isDisabled()} className="w-full text-base" onClick={() => setShowTicketSearchDrawer(true)}>
        {trans('continue')}
      </DefaultButton>
    </div>
  );
}

export default ContinueDrawer;
